import { useEffect } from "react";

/**
 * Custom hook to initialize time picker selection when it opens
 * @param {Object} params - Parameters object
 * @param {Object} params.timePickerOpen - Object containing open state for each picker
 * @param {string} params.startTimeManual24 - Start time in 24hr format
 * @param {string} params.endTimeManual24 - End time in 24hr format
 * @param {string} params.startTimeManual - Start time in 12hr format
 * @param {string} params.endTimeManual - End time in 12hr format
 * @param {Function} params.setTimePickerSelection - Setter for time picker selection state
 */
export function useTimePickerInitialization({
  timePickerOpen,
  startTimeManual24,
  endTimeManual24,
  startTimeManual,
  endTimeManual,
  setTimePickerSelection,
}) {
  useEffect(() => {
    Object.keys(timePickerOpen).forEach((pickerType) => {
      if (timePickerOpen[pickerType]) {
        const is24Hour = pickerType.includes("24");
        let inputValue = "";
        if (pickerType === "start24") inputValue = startTimeManual24;
        else if (pickerType === "end24") inputValue = endTimeManual24;
        else if (pickerType === "start12") inputValue = startTimeManual;
        else if (pickerType === "end12") inputValue = endTimeManual;

        const timeMatch = inputValue.match(/(\d{1,2})[:\s]+(\d{1,2})\s*(AM|PM)?/i);
        if (timeMatch) {
          const [, hour, minute, ampm] = timeMatch;
          setTimePickerSelection(prev => ({
            ...prev,
            [pickerType]: {
              hour: hour.padStart(2, "0"),
              minute: minute.padStart(2, "0"),
              ampm: ampm ? ampm.toUpperCase() : (is24Hour ? null : "AM"),
            },
          }));
        } else {
          setTimePickerSelection(prev => ({
            ...prev,
            [pickerType]: {
              hour: is24Hour ? "00" : "01",
              minute: "00",
              ampm: is24Hour ? null : "AM",
            },
          }));
        }
      }
    });
  }, [timePickerOpen, startTimeManual24, endTimeManual24, startTimeManual, endTimeManual, setTimePickerSelection]);
}
